function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const InstructionButtons = ({ activeInstruction, setActiveInstruction })=>/*#__PURE__*/ _jsxs("ul", {
        className: `list--unstyled ${styles.instructionsButtons}`,
        children: [
            /*#__PURE__*/ _jsx("li", {
                className: styles.instructionButton,
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles.instructionButton__btn,
                    onClick: ()=>setActiveInstruction(1),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: cn(styles.instructionButton__imageContainer, {
                            [styles['instructionButton__imageContainer--active']]: activeInstruction === 1
                        }),
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/assets/svg/type1.svg",
                            alt: ""
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("li", {
                className: styles.instructionButton,
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles.instructionButton__btn,
                    onClick: ()=>setActiveInstruction(2),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: cn(styles.instructionButton__imageContainer, {
                            [styles['instructionButton__imageContainer--active']]: activeInstruction === 2
                        }),
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/assets/svg/type2.svg",
                            alt: ""
                        })
                    })
                })
            })
        ]
    });
const InstructionRound3BtnOKBt = ()=>/*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("ol", {
            className: `${styles.howTo__list} row`,
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.howTo__list__item__content,
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.round3BtnOKBt.first))
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/Round3BtnOKBt-ok.svg",
                                className: styles.instruction__image,
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.howTo__list__item__content,
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.round3BtnOKBt.second))
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/Round3BtnOKBt-up.svg",
                                className: styles.instruction__image,
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.howTo__list__item__content,
                        children: /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.round3BtnOKBt.third))
                        })
                    })
                })
            ]
        })
    });
const InstructionLongLight = ()=>/*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("ol", {
            className: `${styles.howTo__list} row`,
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.howTo__list__item__content,
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.longLight.first))
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/LongLight-off.svg",
                                className: styles.instruction__image,
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.howTo__list__item__content,
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.longLight.second))
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/svg/LongLight-on.svg",
                                className: styles.instruction__image,
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: `${styles.howTo__list__item} col-6`,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.howTo__list__item__content,
                        children: /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.longLight.third))
                        })
                    })
                })
            ]
        })
    });
const Instructions = ({ activeInstruction, setActiveInstruction })=>{
    const Instruction = activeInstruction === 1 ? InstructionRound3BtnOKBt : InstructionLongLight;
    return /*#__PURE__*/ _jsxs("div", {
        className: "pr-4",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.showInstructionsFor))
            }),
            /*#__PURE__*/ _jsx(InstructionButtons, {
                activeInstruction: activeInstruction,
                setActiveInstruction: setActiveInstruction
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader mb-3",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.howToStartConnection))
            }),
            /*#__PURE__*/ _jsx(Instruction, {})
        ]
    });
};
const Meter = ({ discoveredDevice, deviceCaseType, onSetComponent })=>{
    const connect = useAction(actions.connectBluetooth);
    const setFormContext = useAction(App.actions.setFormContext, constants.BLUETOOTH_PIN_FORM);
    const setFormValues = useAction(App.actions.setFormValues, constants.BLUETOOTH_PIN_FORM);
    const { isPaired } = discoveredDevice;
    const { icon } = deviceCaseType;
    const pairedTagMessage = messages.connectBluetooth.tags[isPaired ? 'paired' : 'unpaired'];
    const buttonMessage = messages.buttons[isPaired ? 'download' : 'pairAndDownload'];
    const onDownload = ()=>{
        if (!discoveredDevice.isPaired && discoveredDevice.requiresPin) {
            setFormContext({
                discoveredDevice
            });
            setFormValues({
                deviceId: discoveredDevice.id
            });
            onSetComponent('BluetoothPairingInstruction');
            return;
        }
        connect(discoveredDevice);
    };
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.meters__list__item,
        children: [
            /*#__PURE__*/ _jsx("figure", {
                className: `${styles.meters__list__item__fig} col-2`,
                dangerouslySetInnerHTML: {
                    __html: icon
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: `col ${styles.meters__list__item__name}`,
                children: [
                    discoveredDevice.name,
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("span", {
                            className: cn('tag mt-2', {
                                'tag--success': isPaired
                            }),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, pairedTagMessage))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-auto pr-0",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: buttonMessage,
                    className: "btn--sm",
                    onClick: onDownload
                })
            })
        ]
    });
};
const Meters = ({ discoveredDevices, devicesCaseTypes, onSetComponent })=>{
    const renderDevice = (discoveredDevice, idx)=>/*#__PURE__*/ _jsx(Meter, {
            discoveredDevice: discoveredDevice,
            deviceCaseType: devicesCaseTypes[idx],
            onSetComponent: onSetComponent
        }, discoveredDevice.name);
    return /*#__PURE__*/ _jsxs("div", {
        className: "h-100",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__info ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.metersWithBluetooth))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.meters,
                children: isEmpty(discoveredDevices) ? /*#__PURE__*/ _jsx("div", {
                    className: styles.meters__noMeters,
                    children: /*#__PURE__*/ _jsx("p", {
                        className: styles.meters__noMeters__info,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectBluetooth.noMeters))
                    })
                }) : /*#__PURE__*/ _jsx("ul", {
                    className: styles.meters__list,
                    children: discoveredDevices.map(renderDevice)
                })
            })
        ]
    });
};
const ConnectBluetooth = ({ devicesByChannel, onSetComponent, onSetStyleModifier })=>{
    const connectionId = useSelector(selectors.connectionId);
    const { devices } = useSelector(selectors.downloader);
    const caseTypes = useSelector(App.selectors.caseTypes);
    const [activeInstruction, setActiveInstruction] = useState(1);
    const [discoveredDevices, setDiscoveredDevices] = useState([]);
    const [devicesCaseTypes, setDevicesCaseTypes] = useState([]);
    const startCheckingConnection = useAction(actions.startCheckingConnection);
    const startListeningBluetooth = useAction(actions.startListeningBluetooth);
    const stopListeningBluetooth = useAction(actions.stopListeningBluetooth);
    useEffect(()=>{
        onSetStyleModifier('xl');
        startListeningBluetooth();
        return ()=>{
            onSetStyleModifier(null);
        };
    }, []);
    useEffect(()=>{
        if (connectionId) {
            startCheckingConnection(connectionId);
            onSetComponent('Downloading');
        }
    }, [
        connectionId
    ]);
    useEffect(()=>{
        const newDevicesCaseTypes = [];
        const newDiscoveredDevices = [];
        const bluetoothDevices = get(devicesByChannel, 'Bluetooth', []);
        if (devices && devices.length) {
            for(let i = 0; i < devices.length; i++){
                const newDiscoveredDevice = devices[i];
                const { sku } = newDiscoveredDevice;
                const device = find(bluetoothDevices, {
                    sku
                });
                if (!device) continue;
                const { caseTypeId } = device;
                const caseType = find(caseTypes, {
                    caseTypeId
                });
                if (!caseType) continue;
                newDevicesCaseTypes.push(caseType);
                newDiscoveredDevices.push(newDiscoveredDevice);
            }
        }
        if (newDiscoveredDevices.length) {
            setActiveInstruction([
                'Round3BtnOKBt',
                'Round3BtnOkBtLight'
            ].includes(newDevicesCaseTypes[0].name) ? 1 : 2);
        }
        setDevicesCaseTypes(newDevicesCaseTypes);
        setDiscoveredDevices(newDiscoveredDevices);
    }, [
        devices
    ]);
    const onSetChooseConnection = ()=>{
        stopListeningBluetooth();
        onSetComponent('ChooseConnection');
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-7",
                        children: /*#__PURE__*/ _jsx(Instructions, {
                            activeInstruction: activeInstruction,
                            setActiveInstruction: setActiveInstruction
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-5",
                        children: /*#__PURE__*/ _jsx(Meters, {
                            discoveredDevices: discoveredDevices,
                            devicesCaseTypes: devicesCaseTypes,
                            onSetComponent: onSetComponent
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text--center",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "transparent",
                    labelMessage: messages.buttons.changeDeviceType,
                    className: "btn--no-size text--primary m-0",
                    onClick: onSetChooseConnection
                })
            })
        ]
    });
};
export default ConnectBluetooth;
